<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="workTypeUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="workTypes"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-work-type
      :workType="{ abbreviation: '', description: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-work-type
      :key="workTypeUpdateKey"
      :workType="selectedWorkType"
      :visible="dialogType === 'update'"
      :id="selectedWorkType.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-work-type
      :visible="dialogType === 'delete'"
      :workType="selectedWorkType"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-work-type>
  </div>
</template>

<script>
import CreateWorkType from "./CreateWorkType";
import UpdateWorkType from "./UpdateWorkType";
import DeleteWorkType from "./DeleteWorkType";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateWorkType,
    UpdateWorkType,
    DeleteWorkType,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "description" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      workTypeUpdateKey: null,
      workTypeList: [],
      isLoading: false,
      dialogType: "",
      selectedWorkType: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "workTypes"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchWorkTypes", "createWorkType", "updateWorkType"]),
    editWorkType(workType) {
      this.selectedWorkType = { ...workType };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, workType) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedWorkType = { ...workType };
      }
    },
    openDeleteModal(type, workType) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedWorkType = { ...workType };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedWorkType = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedWorkType = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createWorkType(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateWorkType(item);
      this.workTypeUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchWorkTypes()
        .then(() => {
          //    this.$store.commit("setWorkTypeResults", response.data);
          this.workTypes = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
